import { render, staticRenderFns } from "./Microarray.vue?vue&type=template&id=13d08a88&scoped=true"
import script from "./Microarray.vue?vue&type=script&lang=js"
export * from "./Microarray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d08a88",
  null
  
)

export default component.exports